import { ARMORY_PUBLIC_URL, WIKI_PUBLIC_URL } from '@/config/externalLinks'

type EcosystemNotFoundProps = {
  app: 'armory' | 'wiki'
}

export default function EcosystemNotFound({ app }: EcosystemNotFoundProps) {
  const appLabel = app === 'wiki' ? 'Wiki' : 'Armory'
  const appUrl = app === 'wiki' ? WIKI_PUBLIC_URL : ARMORY_PUBLIC_URL
  const siblingLabel = app === 'wiki' ? 'Armory' : 'Wiki'
  const siblingUrl = app === 'wiki' ? ARMORY_PUBLIC_URL : WIKI_PUBLIC_URL

  return (
    <section className="panel panel-elevated animate-fade-up px-6 py-8 sm:px-10">
      <p className="text-xs uppercase tracking-[0.24em] text-calamity-text-muted">404</p>
      <h1 className="mt-3 text-3xl font-display text-calamity-text">Page Not Found</h1>
      <p className="mt-3 max-w-2xl text-calamity-text-dim">
        This route does not exist in the Calamity {appLabel}. Continue in the ecosystem below.
      </p>

      <div className="mt-6 flex flex-wrap gap-3">
        <a
          href={appUrl}
          className="inline-flex items-center rounded-xl border border-calamity-accent/60 bg-calamity-accent/10 px-4 py-2 text-xs uppercase tracking-[0.2em] text-calamity-text transition-colors hover:border-calamity-accent"
        >
          Open {appLabel}
        </a>
        <a
          href={siblingUrl}
          className="inline-flex items-center rounded-xl border border-calamity-border-subtle bg-calamity-bg-darker/60 px-4 py-2 text-xs uppercase tracking-[0.2em] text-calamity-text-dim transition-colors hover:border-calamity-accent/40 hover:text-calamity-text"
        >
          Open {siblingLabel}
        </a>
      </div>
    </section>
  )
}
